import { RenderElementProps } from 'slate-react';
import { CustomEditor } from 'slate/types/slate';
import { Note } from './components/Note';
import { isNote } from './utils/notes';

const withNotes = (editor: CustomEditor) => {
  const { renderElement } = editor;

  editor.renderElement = (props: RenderElementProps) => {
    if (isNote(props.element)) {
      return <Note {...props} />;
    } else {
      return renderElement(props);
    }
  };

  return editor;
};

export default withNotes;
